import { render } from "./FilterIcon.vue?vue&type=template&id=61cea114"
const script = {}

import "./FilterIcon.vue?vue&type=style&index=0&id=61cea114&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__